export const numericValidationError = (value: string, allowOnlyNumeric: boolean): string => {
  if (allowOnlyNumeric && !/^[0-9]*$/.test(value.trim())) {
    return '半角数字のみ入力可能です'
  }
  return ''
}
